import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
  Typography,
  Upload,
  Flex,
  Collapse,
} from "antd";
import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash, FaUpload } from "react-icons/fa";
import { Editor } from "primereact/editor";
import { apiHandle } from "../../config/apiHandle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getAllStoresAsync } from "../../services/StoreManagementServices";
import {
  getProductByIdAsync,
  myProductsDetailsAsync,
  updateProductAsync,
} from "../../services/ProductManagementServices";
import { asyncStatus } from "../../utils/asyncStatus";
import { setUpdateProductIdleStatus } from "../../store/slice/ProductManagementSlice";
import { getAllTypes, getAllVariants } from "../../services/variantService";

const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;
const { Panel } = Collapse;

const EditProduct = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [duplicateError, setDuplicateError] = useState(null);
  const [uploadingImages, setUploadingImages] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [product, setProduct] = useState({
    name: "",
    description: "",
    category: [],
    images: [],
    gtin_number: "",
    availability: "In-Stock",
    status: "Active",
    faqs: [],
    store: "", // Singular store
    type: "",
    shipping_weight: "",
    country_origin: "",
    hs_number: "",
    variants: [],
  });

  const {
    get_product_by_id_data,
    get_product_by_id_status,
    update_product_status,
  } = useSelector((state) => state.productManagement);

  const { get_all_stores_data } = useSelector((state) => state.storeManagement);
  const { get_variants_data, get_types_data } = useSelector((s) => s.variants);
  const { user } = useSelector((s) => s.userAuth);

  // console.log(get_product_by_id_data);
  useEffect(() => {
    dispatch(getAllVariants());
    dispatch(getAllTypes());
  }, [dispatch]);

  const productLoader = get_product_by_id_status === asyncStatus.LOADING;
  const updateProductLoader = update_product_status === asyncStatus.LOADING;

  const handleImageUpload = async (file) => {
    setUploadingImages((prev) => [...prev, file.uid]);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await apiHandle.post("s3-cloud-storage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response?.data?.files?.url) {
        setProduct((prev) => {
          const updatedImages = [...prev.images, response?.data?.files?.url];
          form.setFieldsValue({ images: updatedImages });
          form.validateFields(["images"]);
          return { ...prev, images: updatedImages };
        });
      }
    } catch (error) {
      console.error("Image upload failed", error);
    } finally {
      setUploadingImages((prev) => prev.filter((id) => id !== file.uid));
    }
    // try {
    //   const response = await apiHandle.post("upload-files", formData, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
    //   if (response.data.url) {
    //     form.setFieldsValue({
    //       images: [...form.getFieldValue("images"), response.data.url],
    //     });
    //   }
    // } catch (error) {
    //   console.error("Image upload failed", error);
    //   message.error("Image upload failed. Please try again.");
    // } finally {
    //   setUploadingImages((prev) => prev.filter((id) => id !== file.uid));
    // }
  };

  const handleRemoveImage = (imageUrl) => {
    setProduct((prev) => ({
      ...prev,
      images: prev.images.filter((image) => image !== imageUrl),
    }));
    form.setFieldsValue({
      images: form
        .getFieldValue("images")
        .filter((image) => image !== imageUrl),
    });
  };

  const addFaq = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  const removeFaq = (index) => {
    const updatedFaqs = faqs.filter((_, i) => i !== index);
    setFaqs(updatedFaqs);
    form.setFieldsValue({ faqs: updatedFaqs });
  };
  useEffect(() => {
    form.setFieldsValue(product);
  }, [product, form]);

  const _addVariant = () => {
    const newVariant = {
      // Temporary ID for React keys
      _tempId: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      price: "",
      discount: "",
      stock_quantity: "",
      sku: "",
    };

    // Initialize variant options
    get_variants_data.forEach((variantType) => {
      newVariant[variantType.name] = "";
    });

    const currentVariants = form.getFieldValue("variants") || [];
    form.setFieldsValue({
      variants: [...currentVariants, newVariant],
    });

    // Force re-render
    setProduct((prev) => ({
      ...prev,
      variants: [...currentVariants, newVariant],
    }));
  };

  const _removeVariant = (index) => {
    const currentVariants = form.getFieldValue("variants") || [];
    const newVariants = currentVariants.filter((_, i) => i !== index);

    form.setFieldsValue({ variants: newVariants });
    setProduct((prev) => ({ ...prev, variants: newVariants }));
  };

  const _updateVariant = (index, field, value) => {
    const currentVariants = [...(form.getFieldValue("variants") || [])];
    currentVariants[index] = {
      ...currentVariants[index],
      [field]: value,
    };

    form.setFieldsValue({ variants: currentVariants });
    setProduct((prev) => ({ ...prev, variants: currentVariants }));
  };

  const handleSubmit = (values) => {
    // console.log("runnn");
    const categoryIds = values?.category?.map((cat) => cat.value || cat);

    const updatedProduct = {
      name: values.name,
      store: values.store,
      description: values.description,
      gtin_number: values.gtin_number,
      category: categoryIds,
      availability: values.availability || "In-Stock",
      status: values.status || "Active",
      images: values.images,
      faqs: values.faqs,
      hs_number: values.hs_number,
      country_origin: values.country_origin,
      shipping_weight: values.shipping_weight,
      variants: product.variants,
      type: values.type,
    };

    if (user.role !== "Vendor") {
      delete updatedProduct.store;
    }
    console.log("updatedProduct", updatedProduct);

    // dispatch(updateProductAsync({ id: id, post_data: updatedProduct }));
  };
  console.log("productinner1234", product);

  const handleDescriptionChange = (content) => {
    form.setFieldsValue({ description: content });
  };

  useEffect(() => {
    dispatch(getAllStoresAsync());
    dispatch(myProductsDetailsAsync());
    dispatch(getProductByIdAsync(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (get_product_by_id_status === asyncStatus.SUCCEEDED) {
      const transformedVariants = get_product_by_id_data?.variants?.map(
        (v) => ({
          ...v,
          ...Object.fromEntries(
            v.options?.map((opt) => [opt.name, opt.value]) || []
          ),
        })
      );

      // console.log("transformedVariants",transformedVariants);

      const productData = {
        variants: transformedVariants || [],
      };

      setProduct(productData);
      form.setFieldsValue(productData);
    }
  }, [get_product_by_id_status]);

  useEffect(() => {
    if (get_product_by_id_status === asyncStatus.SUCCEEDED) {
      console.log("get_product_by_id_data", get_product_by_id_data);

      const productData = {
        name: get_product_by_id_data?.name,
        store: get_product_by_id_data?.store?._id, // Singular store
        description: get_product_by_id_data?.description,
        sku: get_product_by_id_data?.sku,
        gtin_number: get_product_by_id_data?.gtin_number,
        // category: get_product_by_id_data?.category?.map((cat) => cat.name),
        // category: get_product_by_id_data?.category?.map((cat) => cat._id),
        category: get_product_by_id_data?.category?.map((cat) => ({
          value: cat._id,
          label: cat.name,
        })),
        availability: get_product_by_id_data?.availability || "In-Stock",
        status: get_product_by_id_data?.status || "Active",
        images: get_product_by_id_data?.images,
        faqs: get_product_by_id_data?.faqs,
        type: get_product_by_id_data?.type?._id,
        shipping_weight: get_product_by_id_data?.shipping_weight,
        country_origin: get_product_by_id_data?.country_origin,
        hs_number: get_product_by_id_data?.hs_number,
        variants: get_product_by_id_data?.variants || [],
      };

      setProduct({
        ...product,
        ...productData,
      });
      form.setFieldsValue({
        ...productData,
        category: productData.category.map((c) => c.value), // Store just IDs in form
      });

      setFaqs(get_product_by_id_data?.faqs || []);
      form.setFieldsValue(productData);
    }
  }, [get_product_by_id_status, get_product_by_id_data]);

  // console.log("product",product);

  useEffect(() => {
    if (update_product_status === asyncStatus.SUCCEEDED) {
      navigate(-1);
      dispatch(setUpdateProductIdleStatus());
    }
  }, [update_product_status]);

  console.log("product?.images?", product?.images);

  return (
    <div className="flex justify-center">
      {productLoader ? (
        <Flex align="center" gap="middle">
          {" "}
          <Spin size="large" />{" "}
        </Flex>
      ) : (
        <Card className="max-w-3xl w-full shadow-lg rounded-xl overflow-hidden p-2">
          <Row gutter={24}>
            <Col xs={24} md={24} className="p-2">
              <div className="p-4 rounded-lg">
                <div className="flex items-center justify-center w-full">
                  <Title level={4}>Edit Product</Title>
                </div>

                <Form
                  form={form}
                  layout="vertical"
                  className="p-6 bg-gray-100 rounded-lg"
                  onFinish={handleSubmit}
                >
                  <Form.Item
                    label="Product Name"
                    name="name"
                    rules={[
                      { required: true, message: "Product name is required" },
                    ]}
                  >
                    <Input placeholder="Enter product name" />
                  </Form.Item>

                  {/* Store Selection (Singular) */}
                  <Form.Item
                    label="Store"
                    name="store"
                    rules={[
                      { required: true, message: "Please select a store" },
                    ]}
                  >
                    <Select
                      placeholder="Select store"
                      value={product.store}
                      onChange={(value) =>
                        form.setFieldsValue({ store: value })
                      }
                    >
                      {get_all_stores_data?.stores?.map((store) => (
                        <Option key={store._id} value={store._id}>
                          {store.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {/* GTIN Number */}
                  <Form.Item label="GTIN Number" name="gtin_number">
                    <Input placeholder="Enter GTIN Number" />
                  </Form.Item>

                  {/* Shipping Weight */}
                  <Form.Item
                    label={
                      <>
                        Shipping Weight &nbsp; <span> (lb)</span>
                      </>
                    }
                    name="shipping_weight"
                  >
                    <Input placeholder="Enter Shipping Weight (lb)" />
                  </Form.Item>

                  {/* Country/Region of Origin */}
                  <Form.Item
                    label="Country/Region of Origin"
                    name="country_origin"
                  >
                    <Input placeholder="Enter Country/Region of Origin" />
                  </Form.Item>

                  {/* HS Number */}
                  <Form.Item label="HS Number" name="hs_number">
                    <Input placeholder="Enter HS Code" />
                  </Form.Item>

                  {/* Category */}
                  {/* <Form.Item
                      label="Category"
                      name="category"
                      rules={[{ required: true, message: "Please select a category" }]}
                      normalize={(value) =>
                        value?.map((item) => ({ value: item, label: get_product_by_id_data?.categories?.find((cat) => cat._id === item)?.name || item }))
                      } // Ensure proper display
                    >
                      <Select
                        mode="multiple"
                        placeholder="Select category"
                        labelInValue
                        optionLabelProp="label" // Ensures names are displayed
                      >
                        {get_product_by_id_data?.categories?.map((category) => (
                          <Select.Option key={category._id} value={category._id} label={category.name}>
                            {category.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item> */}
                  <Form.Item
                    label="Category"
                    name="category"
                    rules={[
                      { required: true, message: "Please select a category" },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select category"
                      optionLabelProp="label"
                      labelInValue
                    >
                      {get_product_by_id_data?.category?.map((cat) => (
                        <Select.Option
                          key={cat._id}
                          value={cat._id}
                          label={cat.name}
                        >
                          {cat.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {/* <Form.Item
                      label="Category"
                      name="category"
                      rules={[{ required: true, message: "Please select a category" }]}
                    >
                      <Select
                        mode="multiple"
                        placeholder="Select category"
                        optionLabelProp="label"
                      >
                        {get_product_by_id_data?.categories?.map((category) => (
                          <Select.Option
                            key={category._id}
                            value={category._id}
                            label={category.name}
                          >
                            <div className="flex items-center gap-2">
                              <span>{category.name}</span>
                              <span className="text-gray-500 text-xs">
                                ({category._id})
                              </span>
                            </div>
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item> */}

                  {/* Type */}
                  <Form.Item
                    label="Type"
                    name="type"
                    rules={[
                      { required: true, message: "Please select a type" },
                    ]}
                  >
                    <Select placeholder="Select type">
                      {get_types_data?.map((type) => (
                        <Option key={type._id} value={type._id}>
                          {type.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {/* Availability */}
                  <Form.Item label="Availability" name="availability">
                    <Select defaultValue="In-Stock">
                      <Option value="In-Stock">In Stock</Option>
                      <Option value="Out of Stock">Out of Stock</Option>
                    </Select>
                  </Form.Item>

                  {/* Status */}
                  <Form.Item label="Status" name="status">
                    <Select defaultValue="Active">
                      <Option value="Active">Active</Option>
                      <Option value="In-Active">In Active</Option>
                    </Select>
                  </Form.Item>

                  {/* Image Upload */}
                  <Form.Item
                    label="Upload Images"
                    name="images"
                    rules={[
                      {
                        required: true,
                        message: "Please add at least one image",
                      },
                    ]}
                  >
                    <Upload
                      multiple
                      listType="picture-card"
                      showUploadList={false}
                      customRequest={({ file, onSuccess }) => {
                        handleImageUpload(file);
                        setTimeout(() => onSuccess("ok"), 0);
                      }}
                    >
                      <Button icon={<FaUpload />}>Upload</Button>
                    </Upload>
                    <div className="flex flex-wrap mt-2">
                      {product?.images?.map((image, index) => (
                        <div key={index} className="relative m-1">
                          <img
                            src={image}
                            alt={`Uploaded ${index}`}
                            className="w-28 h-28 object-cover rounded-md border"
                          />
                          <Button
                            type="text"
                            className="absolute top-0 right-0 text-red-500 rounded-full shadow p-1"
                            icon={<FaTrash />}
                            onClick={() => handleRemoveImage(image)}
                          />
                        </div>
                      ))}
                      {uploadingImages?.map((id) => (
                        <div
                          key={id}
                          className="w-28 h-28 flex items-center justify-center bg-gray-300 rounded-md m-1"
                        >
                          <Spin />
                        </div>
                      ))}
                    </div>
                  </Form.Item>

                  {/* Product Variants */}
                  <Title level={5}>Product Variants</Title>
                  <Collapse accordion ghost className="mb-4">
                    {product.variants.map((variant, index) => (
                      <Panel
                        key={variant._tempId || index}
                        header={`Variant ${index + 1} - Price: $${
                          variant.price || "0"
                        }`}
                      >
                        <div
                          key={index}
                          className="p-4 bg-white shadow-md rounded-lg mb-4"
                        >
                          {get_variants_data?.map((variantType) => (
                            <Form.Item
                              label={variantType.name}
                              key={variantType._id}
                            >
                              <Select
                                placeholder={`Select ${variantType.name}`}
                                value={variant[variantType.name]}
                                onChange={(value) =>
                                  _updateVariant(index, variantType.name, value)
                                }
                                style={{ width: "100%" }}
                              >
                                {variantType.values.map((value) => (
                                  <Option key={value} value={value}>
                                    {value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          ))}

                          <Form.Item label="SKU" required>
                            <Input
                              type="text"
                              placeholder="Enter sku"
                              value={variant.sku}
                              onChange={(e) =>
                                _updateVariant(index, "sku", e.target.value)
                              }
                            />
                          </Form.Item>

                          <Form.Item label="Price" required>
                            <Input
                              type="number"
                              placeholder="Enter price"
                              value={variant.price}
                              onChange={(e) =>
                                _updateVariant(index, "price", e.target.value)
                              }
                            />
                          </Form.Item>

                          <Form.Item label="Discount Percentage">
                            <Input
                              min={0}
                              type="number"
                              placeholder="Enter discount price"
                              value={variant.discount}
                              onChange={(e) =>
                                _updateVariant(
                                  index,
                                  "discount",
                                  e.target.value
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item label="Stock Quantity">
                            <Input
                              type="number"
                              placeholder="Enter Quantity"
                              value={variant.stock_quantity}
                              onChange={(e) =>
                                _updateVariant(
                                  index,
                                  "stock_quantity",
                                  e.target.value
                                )
                              }
                            />
                          </Form.Item>

                          <Button
                            type="danger"
                            icon={<FaTrash />}
                            onClick={() => _removeVariant(index)}
                          >
                            Remove Variant
                          </Button>
                        </div>
                      </Panel>
                    ))}
                  </Collapse>

                  {/* {duplicateError && (
                      <div className="my-4">
                        <Alert
                          message="Error"
                          description={duplicateError}
                          type="error"
                          showIcon
                        />
                      </div>
                    )} */}

                  <Button type="dashed" icon={<FaPlus />} onClick={_addVariant}>
                    Add Variant
                  </Button>

                  <div className="pt-4">
                    <Form.Item label="Description" name="description">
                      <Editor
                        style={{ height: "200px" }}
                        value={product?.description}
                        onTextChange={(e) =>
                          handleDescriptionChange(e.htmlValue)
                        }
                      />
                    </Form.Item>
                  </div>

                  <Button
                    type="primary"
                    htmlType="submit"
                    className="w-full"
                    loading={updateProductLoader}
                    disabled={updateProductLoader}
                  >
                    Submit
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default EditProduct;
